<i18n>
{
    "en": {
        "paid_periods": "Paid periods",
        "settings": "Settings",
        "description": "Description"
    },
    "ua": {
        "paid_periods": "Платіжні періоди",
        "settings": "Налаштування",
        "description": "Опис"
    },
    "ru": {
        "paid_periods": "Платежные периоды",
        "settings": "Настройки",
        "description": "Описание"
    }
}
</i18n>

<template>
  <el-tabs :stretch="true" v-model="activeName">
    <el-tab-pane label="Paid periods" name="paid_periods">
      <component
        :is="require('./periods_tab_content').default"
        :sharedPeriods.sync="sharedPeriods.periods"
        @savePeriods="handleSavePeriods"
      />
    </el-tab-pane>
    <el-tab-pane :label="$t('settings')" name="settings">
      <el-form v-if="widget && widget.manifestJSON" label-width="115px">
        <template v-for="(v, k) in widget.manifestJSON.settings">
          <el-form-item v-if="k !== 'icon'" :key="k" :label="k">
            <el-input v-model="widget.widgetsJSON[widget.code].settings[k]" />
          </el-form-item>
        </template>
      </el-form>
    </el-tab-pane>
    <el-tab-pane :label="$t('description')" name="fourth">
      <div v-html="widget.description"></div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import SharedCustomersServices from "../../../store/classes/SharedCustomersServices";

export default {
  name: "widget_main_tabs",
  props: {
    widget: {
      type: Object,
      default: null
    },
    amo: {
      type: Object,
      default: null
    },
    customer: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      activeName: this.widget.active ? "paid_periods" : "settings",
      sharedPeriods: {},
      service: {}
    };
  },
  created() {
    if (!this.widget.active) {
      return;
    }
    this.getData();
  },
  methods: {
    getData() {
      this.$api.query(this.refetchQueries[0]).then(res => {
        this.$log(res);
        this.service = new SharedCustomersServices(
          res.data.shared_customers_services
        );
        let sp = this.service._embedded.sharedPeriods;
        sp !== null || (sp = { periods: [] });
        this.sharedPeriods = sp;
      });
    },
    handleSavePeriods() {
      this.$api.mutate({
        mutation: require("../../../graphql/services/services_update.graphql"),
        variables: {
          uuid: this.service.uuid,
          update: {
            periods: this.sharedPeriods,
            amo: this.amo,
            customer: this.customer,
            widget: this.widget
          }
        }
      });
    }
  },
  computed: {
    refetchQueries() {
      return [
        {
          query: require("../../../graphql/services/services.graphql"),
          variables: {
            uuid: Object.values(
              this.widget._embedded.sharedCustomersServices
            )[0].uuid
          }
        }
      ];
    }
  }
};
</script>

<style scoped></style>
